import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Ag1ButtonBaseComponent } from '../ag1-button-base/ag1-button-base.component';
import { Ag1TooltipDirective } from '../../directives/tooltip.directive';
import { SentenceCasePipe } from '../../pipes/sentence.pipe';

/**
 * @deprecated Do not add new instances of this component. Use PrimeNG's 'p-button size='small'' instead.
 */
@Component({
  selector: 'ag1-button-small',
  templateUrl: './ag1-button-small.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Ag1TooltipDirective, SentenceCasePipe],
})
export class Ag1ButtonSmallComponent extends Ag1ButtonBaseComponent {
  // logic implemented inside Ag1ButtonBaseComponent
}
